<template>
  <div class="leave">
    <van-nav-bar
      @click-left="clickBack"
      right-text="我要请假"
      @click-right="clickNavBarRight"
      left-arrow
    >
    </van-nav-bar>

    <!-- <van-nav-bar @click-right="onClickRight">
      <template #left>
        <div style="color: #333">请假审批状态</div>
      </template>
      <template #right>
        <div style="color: #646566">
          {{ selectText }}
          <van-icon name="arrow" color="#646566" />
        </div>
      </template>
    </van-nav-bar> -->

    <van-action-sheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      @select="onSelect"
    />

    <div class="leave-list-wrap">

      <van-list
        ref="list"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        v-if="list.length > 0"
        class="leave-list"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
      <div
          class="leave-list-item"
          v-for="item in list"
          :key="item.id"
          @click="clickLeaveDetail(item)"
        >
          <div class="cause flex flex-b flex-vc">
            <span
              >{{item.leaveName}} {{ item.leaveType }}（共计{{
                renderTime(item.leaveTime,item.workTime)
              }}）</span
            >
            <!-- <span class="status">{{ item.leaveState }}</span> -->
            <van-tag plain type="success" v-if="item.leaveState == 1"
              >已通过</van-tag
            >
            <van-tag plain type="primary" v-if="item.leaveState == 0"
              >待审批</van-tag
            >
            <van-tag plain type="danger" v-if="item.leaveState == -1"
              >已驳回</van-tag
            >
            <van-tag plain type="danger" v-if="item.leaveState == -2"
              >已过期</van-tag
            >
            <van-tag plain type="danger" v-if="item.leaveState == -3"
              >已作废</van-tag
            >
          </div>
          <div class="date">
            <span>开始时间：</span
            ><span>{{ getDateYMD(item.leaveBeginTime) }}</span>
          </div>
          <div class="date">
            <span>结束时间：</span
            ><span>{{ getDateYMD(item.leaveEndTime) }}</span>
          </div>
          <div class="date flex flex-b">
            <div>
              <span>请假原因：</span
              ><span style="word-break: break-all;">{{ item.remark }}</span>
            </div>
            <div
              class="flex flex-vc report"
              v-if="
                item.leaveState == 1 &&
                  item.cancelLeaveState == 0 &&
                  isDuringDate(item.leaveBeginTime, item.leaveEndTime)
              "
            >
              <van-icon name="notes-o" style="margin-right:0.3rem" />
              销假
            </div>
          </div>
         
        </div>
      </van-list>


     
      <div class="" v-if="list.length <= 0">
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { compare, getDateYMD, timeFormart } from '@/utils'

export default {
  data() {
    return {
      list: [],
      show: false,
      actions: [
      {
          name: "待审批",
        },
        {
          name: "已通过",
        },
        {
          name: "已驳回",
        },
        {
          name: "已过期",
        },
        {
          name : '全部'
        }
      ],
      // 选中状态
      selectText: '全部',
      totalPageNum: '',
      pageNum: 1,
      loading: false,
      finished: false,
      error: false

    }
  },
  mounted() {
    Promise.all([
      this.getLeaveList(-11)
    ]).then((res) => {
      // 设置页数
      this.totalPageNum = res[0].totalPage
      this.pageNum = 1
      res.forEach((item) => {
        item.list.forEach((v) => {
          // v.leaveState = this.getStatus(v.leaveState)
          this.list.push(v)
        })
      })
    })
  },
  computed: {},
  methods: {
    getDateYMD,
    getStatus(state) {
      let map = {
        0: '待审批',
        1: '申请成功',
        '-1': '申请失败',
      }
      return map[state]
    },
    clickBack() {
      this.$router.go(-1)
    },
    clickNavBarRight() {
      this.$router.push('/leaveForm')
    },
    clickLeaveDetail(item) {
      this.$router.push({
        path: '/leavedetail',
        query: {
          id: item.id,
          type: 'list',
          approvalId: item.approvalId
        },
      })
    },

    async getLeaveList(state) {
      const { data, code } = await this.$https.getMyStudentLeaveList({
        leaveState: state,
        userId: this.$store.state.puserId,
        schoolId: this.$store.state.pschoolId,
        pageSize: 10,
        pageNum: 1
      })
      if (code !== 200) {
        return false
      }
      return Promise.resolve(data)
    },

    renderTime(leaveTime,workTime) {
      let StatusMinute = ''
      var day = parseInt(leaveTime/workTime);
      var hour = parseInt((leaveTime % workTime) / 60); // 小时
      var min = parseInt((leaveTime % workTime) % 60); // 分钟
      if (day > 0) {
        StatusMinute = day + "天";
      }
      if (hour > 0) {
        StatusMinute += hour + "小时";
      }
      if (min > 0) {
        StatusMinute += parseFloat(min) + "分钟";
      }
      console.log(day,hour,min)
      return `${StatusMinute || '0分钟'}`;

    },


    isDuringDate(s, e) {
      if (moment().isAfter(s) && moment().isBefore(e)) {
        return true
      }
      return false
    },


    onClickRight () {
      this.show = true
    },

    async onSelect (item) {
      this.error = false
      this.finished = false
      this.pageNum = 1
      let obj = {
        待审批: 0,
        已通过: 1,
        已驳回: -1,
        已过期: -2
      }
      this.show = false
      // 获取请假列表
      let leaveList = await this.getApprovalList(obj[item.name],1)
      this.totalPageNum = leaveList.totalPage
      if (leaveList.list){ 
        this.list = leaveList.list
      }
      this.selectText = item.name
    },


    async getApprovalList (state,pageNum) {
      const {data,code} = await this.$https.getMyStudentLeaveList({
        leaveState: state,
        userId: this.$store.state.puserId,
        schoolId: this.$store.state.pschoolId,
        pageSize: 10,
        pageNum
      })
      if (code != 200) {
        return false
      }
      return data
    },

    async onLoad () {
      let obj = {
        待审批: 0,
        已通过: 1,
        已驳回: -1,
        全部: -11,
        已过期: -2,
      };
      this.loading = true
      // 判断滚动加载
      if (this.pageNum == this.totalPageNum) {
        this.finished = true;
      } else if (this.loading && this.pageNum != this.totalPageNum) {
        this.finished = false
        let newList = await this.getApprovalList(obj[this.selectText],this.pageNum + 1)
        if (!newList) {
          this.error = true
          this.loading = false
          return 
        }
        this.list = [...this.list,...newList.list]
        this.pageNum = this.pageNum + 1
        this.totalPageNum = newList.totalPage
        this.loading = false
      }
    }

  },
}
</script>

<style lang="scss" scoped>
.leave-list-wrap {
  .leave-list-title {
    padding: 1rem;
  }
  .leave-list {
    border-radius: 0.75rem;
    border-radius: 1.0625rem;
    margin: 1rem;
    box-shadow: 0rem 1rem 1rem rgba(69, 91, 99, 0.1);
    overflow: hidden;
    .leave-list-item {
      display: flex;
      flex-direction: column;
      padding: 0.75rem;

      background: #fff;
      font-size: 0.75rem;
      color: rgba(120, 132, 158, 1);
      border-bottom: 1px solid #f4f4f6;

      .cause {
        font-size: 1rem;
        font-weight: bold;
        color: #333;
        margin-bottom: 0.55rem;
        .status {
          color: #1989fa;
          font-size: 0.85rem;
        }
      }
      .date {
        margin-bottom: 0.55rem;
      }
    }
  }
}
.report {
  font-size: 1rem;
}
</style>
